<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! childHover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('classes'), classes('customClasses'))">
      <div v-for="section in sections" :key="`container_${section.id}`" :class="elementClasses(classes('containerClasses'))">
        <button
          @click.prevent="toggleSection(section.id)"
          class="hover-trigger focus:wf-outline-none wf-flex wf-w-full wf-justify-between wf-items-center wf-pl-2"
          :style="elementTitleStyles(section.id)"
          :class="elementClasses(classes('titleClasses'))"
        >
          <div class="wf-flex wf-items-center">
            <div
              v-show="content.hasIcon"
              class="wf-flex wf-items-center wf-mr-2 wf-justify-center wf-h-8 wf-w-8"
              :style="elementStyles(styles('iconContainerStyles'))"
              :class="elementClasses(classes('iconContainerClasses'))"
            >
              <i :style="elementStyles(styles('iconStyles'))" class="wf-text-sm" :class="[content.class, content.icon]"></i>
            </div>
            <div @keydown.enter.prevent @input="updateSectionTitle($event.target.textContent, section.id)" :contenteditable="! previewMode" v-text="section.content.title"></div>
            <button
              v-if="sections.length > 1 &&! previewMode"
              @click.prevent="removeSection(section)"
              class="hover-target wf-text-gray-600 wf-h-8 wf-w-8 wf-ml-2 wf-flex wf-items-center wf-justify-center"
            ><i class="fas fa-trash wf-text-sm"></i></button>
          </div>
          <span class="wf-w-8 wf-h-8 wf-items-center wf-flex wf-justify-center wf-inline-block"><i :style="elementChevronStyles(section.id)" class="fas" :class="isOpen(section.id) ? ['fa-chevron-up'] : ['fa-chevron-down']"></i></span>
        </button>
        <EditorComponentSection v-if="isOpen(section.id)" :key="section.id" :parentModule="parentModule"/>
      </div>
      <div v-show="! previewMode">
        <button
          @click.prevent="addAccordion()"
          class="wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-700 hover:wf-text-gray-600 wf-px-4 wf-h-12 wf-w-full wf-text-left wf-bg-gray-300 hover:wf-bg-gray-200"
        >
          <i class="fas fa-plus wf-mr-4"></i>add accordion
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { StylesParser } from '../StylesParser'
  import { TabFactory } from '../factories/TabFactory'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    data() {
      return {
        selectedSections: [],
      }
    },
    created() {
      this.selectedSections.push(this.sections[0].id)
    },
    computed:{
      sections: {
        get() {
          return this.$store.getters['componentSectionModule/elements'](this.element, this.parentModule)
        },
        set(value) {
          this.$store.dispatch('componentSectionModule/updateOrder', {
            ...this.element,
            value
          })
        },
      },
    },
    methods: {
      elementTitleStyles(sectionIndex) {
        if(! this.selectedSections.includes(sectionIndex)) {
          return {...(new StylesParser(this.styles('titleStyles'), this.device)).parse(), ...(new StylesParser(this.styles('inactiveTitleStyles'), this.device)).parse()}
        }
        return {...(new StylesParser(this.styles('titleStyles'), this.device)).parse(), ...(new StylesParser(this.styles('activeTitleStyles'), this.device)).parse()}
      },
      elementChevronStyles(sectionIndex) {
        if(! this.selectedSections.includes(sectionIndex)) {
          return (new StylesParser(this.styles('inactiveChevronStyles'), this.device)).parse()
        }
        return (new StylesParser(this.styles('activeChevronStyles'), this.device)).parse()
      },
      updateSectionTitle: _.debounce(function (newText, updatableSectionId) {
        let sectionIndex = this.sections.findIndex(section => section.id == updatableSectionId)
        this.addToObject('componentSectionModule', {title: newText}, 'content', null, {...this.element, componentSection: sectionIndex})
      }, 1000),
      isOpen(sectionId) {
        return this.selectedSections.includes(sectionId)
      },
      toggleSection(sectionId) {
        if(this.isOpen(sectionId)) {
          return this.selectedSections = this.selectedSections.filter(section => section != sectionId)
        }
        if (this.content.severalOpen) {
          return this.selectedSections.push(sectionId)
        }
        this.selectedSections = [sectionId]
      },
      removeSection(deletableSection) {
        if (! confirm('Are you sure you want to remove this accordion?')) {
          return;
        }
        this.removeFromArray(this.module, [deletableSection], 'sections', null, {}, true, this.parentModule)
      },
      addAccordion(qty = 1) {
        let sections = (new TabFactory(qty)).create()
        this.addToArray(this.module, sections, 'sections', null, {}, true, this.parentModule)
      }
    }
  })
</script>

<style lang="css">
  .hover-trigger .hover-target {
    display: none;
  }

  .hover-trigger:hover .hover-target {
    display: block;
  }
</style>